export default function variationGalleryImage(selector = '.product-gallery-swiper') {
  // console.log('variationGalleryImage');
  const $form = jQuery('form.variations_form');
  if (!$form.length) return;

  const $swiperContainer = jQuery(selector);
  if (! $swiperContainer.length) return;

  let thumbsMap;
  let def_first_img_url;

  let $slides = $swiperContainer.find('.swiper-slide');
  if (! $slides.length) return;
  let $pagination_bullets = $swiperContainer.find('.swiper-pagination__bullet');
  if ($pagination_bullets.length) {
    init();
  }
  else {
    jQuery(document).on('swiperReady', (event) => {
      // console.log('variationGalleryImage swiperReady');
      $pagination_bullets = $swiperContainer.find('.swiper-pagination__bullet');
      if (! $pagination_bullets.length) return;
      init();
    });
  }

  function init() {
    // console.log('variationGalleryImage init');
    try {
      thumbsMap = JSON.parse($swiperContainer.attr('data-variations-thumbs'));
    } catch (e) {
      console.error('Invalid datasheets JSON in', selector);
      return;
    }

    
    def_first_img_url = {
      'src': $slides.eq(0).find('a').attr('href'),
      'srcset': $slides.eq(0).find('a').attr('srcset'),
    }
    // def_first_img_url = $slides.eq(0).find('a').attr('href');

    $form.on('found_variation', function (event, variation) {
      // console.log('variationGalleryImage found_variation');
      updateFirstGalleryItem(variation && variation.variation_id);
    });

    $form.on('reset_data', function () {
      // console.log('variationGalleryImage reset_data');
      resetFirstGalleryItem();
    });

    // Trigger WooCommerce to re-check variations and fire found_variation if possible
    $form.trigger('check_variations');

    refreshFsLightbox();
  }

  function replaceFirstGalleryItem(sources) {
    $slides.eq(0).find('a').attr('href', sources.src);
    $slides.eq(0).find('img').attr('src', sources.src);
    $slides.eq(0).find('img').attr('srcset', sources.srcset);
    $pagination_bullets.eq(0).find('img').attr('src', sources.src);
  }
  // function replaceFirstGalleryItem(url) {
  //   $slides.eq(0).find('a').attr('href', url);
  //   $slides.eq(0).find('img').attr('src', url);
  //   $pagination_bullets.eq(0).find('img').attr('src', url);
  // }
  function resetFirstGalleryItem() {
    $slides.eq(0).find('a').attr('href', def_first_img_url.src);
    $slides.eq(0).find('img').attr('src', def_first_img_url.src);
    $slides.eq(0).find('img').attr('srcset', def_first_img_url.srcset);
    $pagination_bullets.eq(0).find('img').attr('src', def_first_img_url.src);
    // $slides.eq(0).find('a').attr('href', def_first_img_url);
    // $slides.eq(0).find('img').attr('src', def_first_img_url);
    // $pagination_bullets.eq(0).find('img').attr('src', def_first_img_url);
  }
  function updateFirstGalleryItem(variationId) {
    if (variationId && thumbsMap[variationId]) {
      replaceFirstGalleryItem(thumbsMap[variationId]);
      // console.log('Updated first gallery item to', thumbsMap[variationId], 'for variation '.variationId);
    } else {
      resetFirstGalleryItem();
    }
    refreshFsLightbox();
  }
}
